import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../components/molecules/Navbar";
import Footer from "../../../components/molecules/Footer";
import styles from "../index.module.css";
import { useEligibilityData } from "../useEligibilityData";

let Digio: any;

function EligibilityDigilocker() {
  const navigate = useNavigate();
  const userData = useEligibilityData();

  const [authToken, setAuthToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const appId = userData?.applicationId;
    if (!appId) return;
    const token = sessionStorage.getItem("eligibility_auth_token");
    fetch(`${process.env.REACT_APP_DASHBOARD_URL}/admin/application/stage?applicationId=${appId}`,
      { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => res.json())
      .then((res) => {
        const stage: number = res?.data?.stage;
        if (stage === undefined || stage === 24) return;
        const navData = userData;
        if (stage === 9) { navigate("/eligibility/selfie", { replace: true, state: { data: navData } }); return; }
        if (stage === 11) { navigate("/eligibility/agreement", { replace: true, state: { data: navData } }); return; }
        if (stage === 12) { navigate("/eligibility/emandate", { replace: true, state: { data: navData } }); return; }
        if (stage === 8) { navigate("/eligibility/congratulations", { replace: true, state: { data: navData } }); return; }
        if (stage === 5) { navigate("/eligibility/under-review", { replace: true, state: { data: navData } }); return; }
        if (stage === 25) { navigate("/eligibility/evaluating", { replace: true, state: { data: navData } }); return; }
        if (stage === 18) { navigate("/eligibility/rejected", { replace: true, state: { data: navData } }); return; }
        if (stage === 10) { navigate("/eligibility/waiting", { replace: true, state: { data: navData, fromStage10: true } }); return; }
      })
      .catch(() => {});
  }, [userData?.applicationId]);

  useEffect(() => {
    if (!userData?.userId) return;
    const eligToken = sessionStorage.getItem("eligibility_auth_token");
    fetch(`${process.env.REACT_APP_DASHBOARD_URL}/integrations-login/generate-token`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(eligToken ? { Authorization: `Bearer ${eligToken}` } : {}),
      },
      body: JSON.stringify({
        mobile: (userData?.mobile || "").replace(/\D/g, "").slice(-10),
        userId: userData?.userId,
        applicationId: userData?.applicationId,
      }),
    })
      .then((res) => res.json())
      .then((data) => setAuthToken(data.data))
      .catch(() => {});
  }, [userData?.userId, userData?.applicationId]);

  const fetchJsFromCDN = (src: string, externals: string[]) =>
    new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.setAttribute("src", src);
      script.addEventListener("load", () =>
        resolve(externals.map((key) => (window as any)[key]))
      );
      script.addEventListener("error", reject);
      document.body.appendChild(script);
    });

  const handleDigilocker = () => {
    if (!authToken) {
      setError("Please wait while we load the verification service.");
      return;
    }
    setLoading(true);
    setError("");
    fetchJsFromCDN(process.env.REACT_APP_DIGIO_SDK as string, ["Digio"])
      .then((digio: any) => {
        fetch(`${process.env.REACT_APP_DASHBOARD_URL}/digilocker/create`, {
          method: "POST",
          headers: { Authorization: `Bearer ${authToken}` },
          redirect: "follow",
        })
          .then((res) => res.json())
          .then((result) => {
            const { kid, tokenId } = result.data;
            Digio = digio[0];
            const d = new Digio({
              environment: process.env.REACT_APP_DIGIO_ENV,
              logo: "yourlogourl",
              theme: { primaryColor: "#234FDA", secondaryColor: "#234FDA" },
              is_iframe: true,
              callback: (_digio: any) => {
                setLoading(false);
                if (_digio.error_code !== undefined) {
                  if (_digio.error_code !== "CANCELLED") {
                    setError(_digio.message || "Verification failed. Please try again.");
                  }
                  return;
                }
                navigate("/eligibility/waiting", { replace: true, state: { data: userData, fromDigilocker: true } });
              },
            });
            d.init();
            d.submit(kid, userData?.mobile, tokenId);
          })
          .catch(() => {
            setLoading(false);
            setError("Failed to start verification. Please try again.");
          });
      })
      .catch(() => {
        setLoading(false);
        setError("Failed to load verification SDK. Please try again.");
      });
  };

  const features = [
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 2L3 7V12C3 16.55 6.84 20.74 12 22C17.16 20.74 21 16.55 21 12V7L12 2Z"
            stroke="#d32028"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 12L11 14L15 10"
            stroke="#d32028"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      label: "Secure",
      desc: "256-bit encrypted",
    },
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="9" stroke="#d32028" strokeWidth="1.7" />
          <path
            d="M12 7V12L15 14.5"
            stroke="#d32028"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      label: "Instant",
      desc: "Processing",
    },
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
          <rect x="3" y="6" width="18" height="14" rx="2" stroke="#d32028" strokeWidth="1.7" />
          <path d="M3 10H21" stroke="#d32028" strokeWidth="1.7" />
          <path
            d="M7 15H10M14 15H17"
            stroke="#d32028"
            strokeWidth="1.7"
            strokeLinecap="round"
          />
        </svg>
      ),
      label: "Official",
      desc: "Govt. of India",
    },
  ];

  const checkItems = [
    "Aadhaar-linked mobile number",
    "Aadhaar number",
    "Access to your phone for OTP",
  ];

  return (
    <div className={styles.body}>
      <div className={styles.backdrop}>
        <Navbar />
        <div className={styles.main}>
          <div className={styles.cardWrapper}>
            <div className={styles.container}>

              {/* ── Header ── */}
              <div className={styles.cardHeader}>
                <div
                  style={{
                    width: "2.4rem",
                    height: "2.4rem",
                    borderRadius: "50%",
                    background: "#F4E5DD",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <svg width="18" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 2L3 7V12C3 16.55 6.84 20.74 12 22C17.16 20.74 21 16.55 21 12V7L12 2Z"
                      fill="#d32028"
                      opacity="0.15"
                      stroke="#d32028"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M9 12L11 14L15 10"
                      stroke="#d32028"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <p className={styles.cardTitle}>KYC Verification</p>
              </div>

              {/* ── Hero illustration ── */}
              <div style={{ display: "flex", justifyContent: "center", padding: "0.3rem 0 0.2rem" }}>
                <svg
                  width="130"
                  height="100"
                  viewBox="0 0 200 155"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {/* Background glow */}
                  <ellipse cx="100" cy="80" rx="72" ry="60" fill="#fff5f5" />

                  {/* ID card body */}
                  <rect x="42" y="40" width="80" height="92" rx="8" fill="white" stroke="#f9d8d6" strokeWidth="1.5" />

                  {/* Card top stripe */}
                  <rect x="42" y="40" width="80" height="18" rx="8" fill="#fde8e8" />
                  <rect x="42" y="50" width="80" height="8" fill="#fde8e8" />

                  {/* Avatar circle */}
                  <circle cx="64" cy="80" r="12" fill="#fde8e8" />
                  <path
                    d="M64 75C65.66 75 67 73.66 67 72C67 70.34 65.66 69 64 69C62.34 69 61 70.34 61 72C61 73.66 62.34 75 64 75Z"
                    fill="#d32028"
                    opacity="0.5"
                  />
                  <path
                    d="M56 83C56 79.69 59.58 77 64 77C68.42 77 72 79.69 72 83"
                    stroke="#d32028"
                    strokeWidth="1.3"
                    strokeLinecap="round"
                    opacity="0.5"
                  />

                  {/* Text lines */}
                  <rect x="82" y="72" width="30" height="5" rx="2.5" fill="#f9d8d6" />
                  <rect x="82" y="82" width="22" height="4" rx="2" fill="#f0e4e4" />
                  <rect x="52" y="100" width="56" height="4" rx="2" fill="#f0e4e4" />
                  <rect x="52" y="109" width="40" height="4" rx="2" fill="#f0e4e4" />
                  <rect x="52" y="118" width="48" height="4" rx="2" fill="#f0e4e4" />

                  {/* Shield badge (right side) */}
                  <g transform="translate(102, 28)">
                    {/* Shield shadow */}
                    <path
                      d="M30 8L10 17V30C10 41.6 18.4 52.5 30 55C41.6 52.5 50 41.6 50 30V17L30 8Z"
                      fill="#d32028"
                      opacity="0.1"
                      transform="translate(2, 2)"
                    />
                    {/* Shield body */}
                    <path
                      d="M30 8L10 17V30C10 41.6 18.4 52.5 30 55C41.6 52.5 50 41.6 50 30V17L30 8Z"
                      fill="#d32028"
                    />
                    {/* Shield highlight */}
                    <path
                      d="M30 8L10 17V30C10 41.6 18.4 52.5 30 55C41.6 52.5 50 41.6 50 30V17L30 8Z"
                      fill="white"
                      opacity="0.12"
                    />
                    {/* Checkmark */}
                    <path
                      d="M22 31L27.5 37L38 24"
                      stroke="white"
                      strokeWidth="3.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>

                  {/* Decorative circles */}
                  <circle cx="36" cy="36" r="4" fill="#fde8e8" />
                  <circle cx="165" cy="118" r="5" fill="#fde8e8" />
                  <circle cx="160" cy="42" r="3" fill="#f9d8d6" />
                  <circle cx="28" cy="120" r="3" fill="#fde8e8" />
                  <circle cx="175" cy="70" r="2.5" fill="#f9d8d6" />

                  {/* Connecting dotted line from card to shield */}
                  <line x1="122" y1="65" x2="140" y2="55" stroke="#f9d8d6" strokeWidth="1.2" strokeDasharray="3 3" />
                </svg>
              </div>

              {/* ── Description ── */}
              <p
                style={{
                  textAlign: "center",
                  fontSize: "0.66rem",
                  color: "#666",
                  margin: "0 0 0.65rem",
                  lineHeight: 1.55,
                }}
              >
                Verify your identity using Digilocker — India's official digital document wallet. Your Aadhaar details will be fetched securely.
              </p>

              {/* ── Feature tiles ── */}
              <div style={{ display: "flex", gap: "0.55rem", marginBottom: "0.65rem" }}>
                {features.map((item) => (
                  <div
                    key={item.label}
                    style={{
                      flex: 1,
                      background: "#fff9f9",
                      border: "1px solid #f9d8d6",
                      borderRadius: "10px",
                      padding: "0.55rem 0.4rem",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: "0.2rem",
                      }}
                    >
                      {item.icon}
                    </div>
                    <div
                      style={{
                        fontSize: "0.78rem",
                        fontWeight: 700,
                        color: "#222",
                        marginBottom: "0.12rem",
                      }}
                    >
                      {item.label}
                    </div>
                    <div style={{ fontSize: "0.57rem", color: "#999" }}>{item.desc}</div>
                  </div>
                ))}
              </div>

              {/* ── Keep ready checklist ── */}
              <div
                style={{
                  background: "#fafafa",
                  border: "1px solid #efefef",
                  borderRadius: "10px",
                  padding: "0.65rem 1rem",
                }}
              >
                <p
                  style={{
                    fontSize: "0.82rem",
                    fontWeight: 700,
                    color: "#333",
                    margin: "0 0 0.35rem",
                  }}
                >
                  Keep ready:
                </p>
                {checkItems.map((item) => (
                  <div
                    key={item}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.6rem",
                      marginBottom: "0.25rem",
                    }}
                  >
                    <div
                      style={{
                        width: "13px",
                        height: "13px",
                        borderRadius: "50%",
                        background: "#d32028",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <svg width="8" height="7" viewBox="0 0 9 7" fill="none">
                        <path
                          d="M1.5 3.5L3.5 5.5L7.5 1.5"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <span style={{ fontSize: "0.66rem", color: "#555" }}>{item}</span>
                  </div>
                ))}
              </div>

              {/* ── PAN info tip ── */}
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "0.5rem",
                  background: "#f0f6ff",
                  border: "1px solid #cce0ff",
                  borderRadius: "8px",
                  padding: "0.55rem 0.75rem",
                  marginTop: "0.6rem",
                }}
              >
                <span style={{ fontSize: "0.8rem", flexShrink: 0 }}>ℹ️</span>
                <span style={{ fontSize: "0.66rem", color: "#444", lineHeight: "1.4" }}>
                  Keep your <strong>PAN card</strong> handy — if it's not fetched via DigiLocker, you'll be asked to upload it in the next steps.
                </span>
              </div>

              {/* ── Powered by Digio ── */}
              <p
                style={{
                  fontSize: "0.68rem",
                  color: "#bbb",
                  textAlign: "center",
                  marginTop: "0.5rem",
                  marginBottom: 0,
                }}
              >
                Powered by{" "}
                <img
                  src="https://www.digio.in/images/digio_blue.png"
                  alt="Digio"
                  style={{ height: "0.85rem", verticalAlign: "middle", marginLeft: "0.2rem" }}
                />
              </p>

              {error && (
                <p
                  style={{
                    color: "#d32028",
                    fontSize: "0.85rem",
                    marginTop: "0.75rem",
                    marginBottom: 0,
                  }}
                >
                  {error}
                </p>
              )}
            </div>

            {/* ── Skip + Proceed ── */}
            <div style={{ padding: "0rem 1.25rem 1rem", display: "flex", flexDirection: "row", alignItems: "center",justifyContent:'center', gap: "0.6rem" }}>
              <button
                onClick={handleDigilocker}
                disabled={loading}
                style={{
                  width: "75%",
                  padding: "0.8rem 1.5rem",
                  background: loading ? "#aaa" : "#d32028",
                  color: "#fff",
                  border: "none",
                  borderRadius: "60px",
                  fontSize: "0.9rem",
                  fontWeight: 700,
                  fontFamily: "Outfit, sans-serif",
                  cursor: loading ? "not-allowed" : "pointer",
                  letterSpacing: "0.3px",
                  whiteSpace: "nowrap",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.5rem",
                }}
              >
                {loading ? "Loading..." : (
                  <>
                    Proceed to DigiLocker
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M5 12H19M13 6L19 12L13 18" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </>
                )}
              </button>
              {process.env.REACT_APP_CURRENT !== 'prod' && (
                <button
                  onClick={() => navigate("/eligibility/address", { state: { data: userData } })}
                  style={{ background: "none", border: "none", color: "#bbb", fontSize: "0.78rem", cursor: "pointer", fontFamily: "Outfit, sans-serif", textDecoration: "underline" }}
                >
                  Skip
                </button>
              )}
            </div>
            <Footer light />
          </div>
        </div>
      </div>
    </div>
  );
}

export default EligibilityDigilocker;
